import React, { useContext, useEffect } from 'react'
import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import Copy from '../../assets/Copy.svg';
import Success from '../../assets/SuccessMark.svg';

import './FTTHSuccess.scss';

function FTTHSuccess() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, LeadRequestId } = state;
    const category = state.gisZone?.Data?.Category ? state.gisZone.Data.Category : 'A';
    const { t } = useTranslation();

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);

    const handleCopyOrderId = () => {
        navigator.clipboard.writeText(LeadRequestId)
    }

    return (
        <main className='FTTH__SuccessContainer'>

            <div className='DCS__Section'>
                <div className='DCS__HeadingSection'>
                    <img src={Success} alt='success' />
                    <div className='DCS__Subheading'>
                        <Typography className='title'>{t('Order_confirmation_title')}</Typography>
                        <Typography className='subTitle'>{t('Order_confirmation_SMS')}</Typography>
                    </div>
                </div>

                <div className='DCS__OrderSection'>
                    <div className='DCS__OrderNumber'>
                        <Typography rtl={rtl} className='order-title'>{t('Order_number')}</Typography>
                        <Typography rtl={rtl} className='order-value'># {LeadRequestId}</Typography>
                    </div>
                    <img onClick={handleCopyOrderId} src={Copy} alt='Copy' className='DCS__OrderCopy' />
                </div>

                <div className='DCS__TrackingSection'>
                    <div className='DCS__Track'>
                        <Typography rtl={rtl} className='track-title'>{t('What_happens')}</Typography>

                        <div className='Track__Details'>
                            <div className='TD__Description'>
                                <Typography rtl={rtl} className='sub-title'>
                                    {category === 'A' ?
                                        t('CategoryA_Success')
                                            .replace('XXXXXXXXX', LeadRequestId)
                                            .replace('ززززززززززز', LeadRequestId)
                                        :
                                        t('CategoryB_Success')
                                            .replace('XXXXXXXXX', LeadRequestId)
                                            .replace('ززززززززززز', LeadRequestId)
                                    }
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default FTTHSuccess